import angular from 'angular';

const module = angular.module('whyline.directives.fileOnChange', []);

const fileOnChange = () => {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onChangeHandler = scope.$eval(attrs.fileOnChange);
            element.bind('change', onChangeHandler);
        }
    };
};

module.exports = module.directive('fileOnChange', fileOnChange);